<button (click)="decrement()" class="btn btn-minus">
  <svg width="14" height="10">
    <use xlink:href="#minus2"></use>
  </svg>
</button>

<input
  type="number"
  [value]="number"
  [readOnly]="!editable"
  (input)="onInput($event)"
  [disabled]="disabled" />

<button (click)="increment()" class="btn btn-plus">
  <svg width="12" height="12">
    <use xlink:href="#plus2"></use>
  </svg>
</button>
